import React, { Component } from 'react';

import classes from './TestimonialCarouselItem.module.scss';

/**
 * CHECKED-2021
 */
class Testimonial extends Component {

    render() {

        return (
            <div className={"w-100 " + classes.testimonialCarouselItemContainer}>

                {/*<img className={"pb-3"} src={require("../../../../assets/images/icons/ico-quote.svg").default} alt=""/>*/}

                {/*<div className={"testimonials-text secondary-text"} dangerouslySetInnerHTML={{__html: this.props.testimonial.content}} />*/}

                <p>
                    "
                    <span dangerouslySetInnerHTML={{__html: this.props.testimonial.content}} />
                    "
                </p>



                <p className={"p-regular mt-3"}>
                    {this.props.testimonial.source}
                </p>
            </div>
        );
    }
}

export default Testimonial;
